import styled from 'styled-components';
import {JackpotAmountDefaultBox} from './jackpot-amount.default.box';
import {baseColors} from "../../../../../themes/definitions/casino777/base-colors";

export const JackpotAmountCasino777Box = styled(JackpotAmountDefaultBox)`
    ${({theme}) => theme.font.presets.secondary};
    font-weight: 300;
    color: ${baseColors.base04Dark};
    text-shadow: 3px 3px 0 ${props => props.theme.colors.textLight}, 0 0 0 ${props => props.theme.colors.textLight}, 1px 1px 0 ${props => props.theme.colors.textLight}, 2px 2px 0 ${props => props.theme.colors.textLight}, 0 0 0 ${props => props.theme.colors.textLight};
    -webkit-text-stroke-width: .5px;
    -webkit-text-stroke-color: ${props => props.theme.colors.textLight};

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        color: ${props => props.theme.colors.textLight};
        text-shadow: none;
        letter-spacing: .3px;
        -webkit-text-stroke-width: 0;
        -webkit-text-stroke-color: transparent;
    }
`;
